import React, {useEffect, useState} from 'react';

import styles from './Reviews.module.css'
import {Review} from "./components/Review.tsx";
import {Slider} from "../../ui/DataDisplay/Slider/Slider.tsx";
import {useScreenDetector} from "../../hooks/useScreenDetector.ts";
import { API_URL } from '../../config.tsx';

interface Props {}

export const Reviews: React.FC<Props> = () => {
    const {isMobile} = useScreenDetector();
    const slidesToShow = isMobile ? 1 : 3;
    const [reviews, setReviews] = useState([]);
    const getReviews = () => {
        fetch(`${API_URL}/reviews`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(cart => setReviews(cart))
    };
    useEffect(() => {
        getReviews();
    }, []);

    return (
        <section className={styles.container}>
            <Slider
                autoTimer={5000}
                slidesToShow={slidesToShow}
                slides={reviews.map(({id, text, author, date}) => (
                    {id, content: <Review author={author} date={date} text={text} />}
                ))}
            />
        </section>
    );
};
